// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1Egtb","label":"CategoryService_label__ShGBg","location":"CategoryService_location__m1CYQ"};